import { getUrlParamsFetch, handleAxiosError, urlBackend } from "@/shared";
import { erpApi } from '@/shared/axios/erp-api';
import { UseMutationsParams } from '@/shared/interfaces';
import { Flota, FlotasPagingRes, IFlotaParams } from '@/shared/interfaces/erp/mantenimiento-operaciones';
import { IFechasDisponible } from '@/shared/interfaces/erp/system-settings/horas-libres-flota.interface';
import { useMutation, useQuery } from "@tanstack/react-query";


const { get, post } = erpApi();

export const useFetchFlota = (params: IFlotaParams) => {
  return useQuery({
    queryKey: ['flota', ...Object.values(params || {})],
    queryFn: async () => {
      return getFlotas(params)
    },
    enabled: params.enabled
  });

}

export const getFlotas = async (params: IFlotaParams) => {

  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<FlotasPagingRes>(`${urlBackend}api/v1/flota/?${queryParams}`, true);

  return resp.data.data
}


export const getFlotaAll = async (params: IFlotaParams) => {

  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<FlotasPagingRes>(`${urlBackend}api/v1/flota/?${queryParams}`, true);

  return resp
}


/**
 * OBTENER LAS HORAS DISPONIBLES
 * 
*/


type PostHorasDisponiblesParams = {
  flota: string
  incluir_expirados: boolean
  incluir_bloqueos_softnet?: boolean
  limite: number
  fecha?: string
}
export const usePostHorasDisponiblesFlota = ({
  enableAlert = true
}: UseMutationsParams) => {

  return useMutation({
    mutationFn: async (data: PostHorasDisponiblesParams) => {
      console.log(data);

      return postHorasDisponiblesFlota(data);
    },
    onError: e => {
      enableAlert && handleAxiosError(e);
    }
  })
}

export const postHorasDisponiblesFlota = async (data: PostHorasDisponiblesParams) => {
  const resp = await post<IFechasDisponible[]>(`${urlBackend}api/v1/obtener-time-maps/`, data, true)
  return resp
}

///* fetch para el autcomplete

export const fetchAutocompleteFlota = async (
  searchValue: string,
  page: number
): Promise<{ options: Flota[]; hasMore: boolean }> => {
  const query = getUrlParamsFetch({
    estado: true,
    nombre: searchValue,
    page,
  });

  const response = await get<FlotasPagingRes>(`${urlBackend}api/v1/flota/?${query}`, true);
  return {
    options: response.data.data,
    hasMore: true,
  };
};

export const fetchAutocompleteFlotaSimple = async (
  query: string
): Promise<{ options: Flota[]; hasMore: boolean }> => {

  const response = await get<FlotasPagingRes>(`${urlBackend}api/v1/flota/?${query}`, true);

  return {
    options: response.data.data,
    hasMore: true,
  };
};
